import {Component, Vue} from 'vue-property-decorator'
import {
    addOutputTemplate, getEmailList, getOutputTemplateById,
    updateOutputTemplate
} from "@/api/classManage";
import commonData from "@/utils/commonData"
import E from "wangeditor";
import {delNullProperty} from "@/utils";

@Component({})
export default class AddProduceMould extends Vue {
    formModel = {
        name: '',
        subjectStr: '',
        souCourseTypeId: '',// 编辑
        souCourseTypeIdList: [], //新建
        ccStr: '',
        bccStr: '',
        contentStr: '',
        emailUser: '',
        types: '0',
    }
    formRules = {
        name: [{required: true, message: '请填写模版名称', trigger: ['blur', 'change']}],
        souCourseTypeId: [{required: true, message: '请选择项目类型', trigger: ['blur', 'change']}],
        souCourseTypeIdList: [{required: true, message: '请选择项目类型', trigger: ['blur', 'change']}],
        subjectStr: [{required: true, message: '请填写邮件主题', trigger: ['blur', 'change']}],
        emailUser: [{required: true, message: '请选择发送邮箱', trigger: 'change'}],
    }
    recordId = null //判断是否是编辑
    typeList = commonData.projectTypeArray
    // 开课时间
    isShow = null
    disabledBtn = false
    name = '' // 远程搜索name
    loading = false
    editor: any = null

    outputTemplateList = [] // 模板列表
    recipientList = [
        '班主任/项目负责人', '论文班主任', '小助手', '订单负责人'
    ]
    recipientList1 = [
        '学生姓名', '开课时间', '项目名称'
    ]
    checkedTags = []
    checkedEmailTags = [] //存放邮件主题
    checkedSecretTags = []
    blurIndex = null
    emailUserList = []

    created() {
        // 编辑
        this.recordId = this.$route.query.id ? String(this.$route.query.id) : null
        if (this.recordId) {
            this.getDataInfo()
        }
        this.getEmailList()

        /*从产出过来的*/
        if (this.$route.query.produceTypes)
            this.formModel.types = String(this.$route.query.produceTypes)
    }


    mounted() {
        this.initEditor()
    }

    /*获取邮箱列表*/
    getEmailList() {
        getEmailList().then((res: any) => {
            this.emailUserList = res.outputTemplateEmailList
        })
    }


    handleAppendTagToEditor(item) {
        // 在光标处插入文本，可多次插入tag
        this.editor.cmd.do('insertHTML', `<input type="button" value="${item}"  style="display: inline-block;
            border: 1px solid #d9ecff;
            border-radius: 5px;
            padding: 0 5px;
            background: #edf5ff;
            color: #469fff;
            height: 24px;
            line-height: 24px;
            margin: 0; " />`)
    }

    // 初始化富文本编辑器
    initEditor() {
        this.editor = new E('#editor-box')
        this.editor.config.height = 200
        this.editor.config.excludeMenus = [
            'fontName',
            'link',
            'code',
            'splitLine',
            'table',
            'video',
            'audio',
        ]
        // this.editor.config.uploadImgServer = 'http://192.168.1.71:10068/uploadFile'
        // this.editor.create()
        this.editor.config.uploadImgShowBase64 = true // 使用 base64 保存图片
        // 隐藏“网络图片”tab
        this.editor.config.showLinkImg = false
        // 创建编辑器
        this.editor.create()
    }

    /*邮箱校验规则*/
    validateEmail(email) {
        const emailRegex = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,6}$/;
        return emailRegex.test(email);
    }


    // 保存
    doSave() {
        let flag = true;
        (this.$refs.dynamicValidateForm as HTMLFormElement).validate((valid: boolean) => {
            if (!valid) {
                flag = false
                return;
            }
        })

        if (!this.editor.txt.html()) {
            this.$message.error('请填写正文')
            return
        }

        /*校验邮箱是否合规*/
        if (this.formModel.ccStr) {
            let emailarr = this.formModel.ccStr.split(',')
            /*校验数组的每一项是否符合规则*/
            /*每一项item都去掉首尾空格*/
            emailarr = emailarr.map(item => item.trim())
            this.formModel.ccStr = emailarr.join(',')
            if (emailarr.some(item => !this.validateEmail(item))) {
                this.$message.error('抄送人邮箱格式不正确')
                flag = false
                return
            }
        }
        if (this.formModel.bccStr) {
            let emailarr1 = this.formModel.bccStr.split(',')
            emailarr1 = emailarr1.map(item => item.trim())
            this.formModel.bccStr = emailarr1.join(',')
            if (emailarr1.some(item => !this.validateEmail(item))) {
                this.$message.error('密送人邮箱格式不正确')
                flag = false
                return
            }
        }


        /*标签更换字符*/
        //抄送
        let ccStrArr = this.checkedTags.join(',')

        // 将所有的班主任/项目负责人 替换成 ${teacherUserId}
        ccStrArr = ccStrArr.replace(/班主任\/项目负责人/g, '${teacherUserId}')
        ccStrArr = ccStrArr.replace(/论文班主任/g, '${thesisUserId}')
        ccStrArr = ccStrArr.replace(/小助手/g, '${helperUserId}')
        ccStrArr = ccStrArr.replace(/订单负责人/g, '${directorUserId}')

        let ccStr = this.formModel.ccStr + ',' + ccStrArr
        /*如果逗号前面没有字符 将逗号去调*/
        ccStr = ccStr.replace(/,/g, function (match, index) {
            if (index == 0) {
                return ''
            } else if (index == ccStr.length - 1) {
                return ''
            } else {
                return ','
            }
        })
        // 密送
        let bccStrArr = this.checkedSecretTags.join(',')

        // 将所有的班主任/项目负责人 替换成 ${teacherUserId}
        bccStrArr = bccStrArr.replace(/班主任\/项目负责人/g, '${teacherUserId}')
        bccStrArr = bccStrArr.replace(/论文班主任/g, '${thesisUserId}')
        bccStrArr = bccStrArr.replace(/小助手/g, '${helperUserId}')
        bccStrArr = bccStrArr.replace(/订单负责人/g, '${directorUserId}')

        let bccStr = this.formModel.bccStr + ',' + bccStrArr
        bccStr = bccStr.replace(/,/g, function (match, index) {
            if (index == 0) {
                return ''
            } else if (index == bccStr.length - 1) {
                return ''
            } else {
                return ','
            }
        })

        // 正文
        // this.formModel.contentStr = this.editor.txt.html()

        let str = this.editor.txt.html();
        // 使用正则表达式全局替换，处理可能的属性顺序变化
        str = str.replace(/<input[^>]*value="学生姓名"[^>]*>/g, '${customerName}');
        str = str.replace(/<input[^>]*value="开课时间"[^>]*>/g, '${souCourseSchoolBegin}');
        str = str.replace(/<input[^>]*value="项目名称"[^>]*>/g, '${souCourseName}');

        if (!flag) {
            return
        } else {
            this.disabledBtn = true
        }

        const obj: any = {
            name: this.formModel.name,
            souCourseTypeIdList: this.formModel.souCourseTypeIdList,
            contentStr: str,
            subjectStr: this.formModel.subjectStr,
            ccStr: ccStr,
            bccStr: bccStr,
            emailUser: this.formModel.emailUser,
            types: this.formModel.types,
        }
        this.loading = true
        addOutputTemplate(delNullProperty(obj)).then((res: any) => {
            this.$message.success('新建保存成功')
            this.disabledBtn = false
            this.loading = false
            setTimeout(() => {
                window.close()
            }, 500)
        }).catch(() => {
            this.disabledBtn = false
            this.loading = false
        })
    }


    /*--------新的*/
    handleChoiceTags(item) {
        /*若是数组里包含item 则不往里push*/
        if (this.checkedTags.indexOf(item) !== -1) {
            return
        }
        this.checkedTags.push(item)
    }

    clearRangeTags(item) {
        /*如果数组的某一项等于item 则删掉item*/
        for (let i = 0; i < this.checkedTags.length; i++) {
            if (this.checkedTags[i] == item) {
                this.checkedTags.splice(i, 1)
            }
        }
    }

    handleChoiceSecretTags(item) {
        if (this.checkedSecretTags.indexOf(item) !== -1) {
            return
        }
        this.checkedSecretTags.push(item)
    }

    clearRangeSecretTags(item) {
        /*如果数组的某一项等于item 则删掉item*/
        for (let i = 0; i < this.checkedSecretTags.length; i++) {
            if (this.checkedSecretTags[i] == item) {
                this.checkedSecretTags.splice(i, 1)
            }
        }
    }


    // 获取光标所在位置的index
    blurEvent1(e) {
        this.blurIndex = e.srcElement.selectionStart;
        // console.log(e.srcElement.selectionStart) //光标所在的位置
    }


    // 插入内容的方法
    insertContentHandle1(text) {
        let txt = ''
        if (text == '学生姓名') {
            txt = '${customerName} '
        } else if (text == '开课时间') {
            txt = '${souCourseSchoolBegin} '
        } else if (text == '项目名称') {
            txt = '${souCourseName} '
        }
        const index = this.blurIndex
        const str = this.formModel.subjectStr
        /*如果添加过此txt 则不再添加*/
        if (str.indexOf(txt) !== -1) {
            return
        }
        this.formModel.subjectStr = str.slice(0, index) + txt + str.slice(index);
        /*插入字符后更改光标初始位置到所插入字符后面*/
        this.blurIndex = this.blurIndex + txt.length
    }

    /*编辑保存*/
    doEditSave() {
        let flag = true;
        (this.$refs.dynamicValidateForm as HTMLFormElement).validate((valid: boolean) => {
            if (!valid) {
                flag = false
                return;
            }
        })

        if (!this.editor.txt.html()) {
            this.$message.error('请填写正文')
            return
        }
        /*校验邮箱是否合规*/
        if (this.formModel.ccStr) {
            let emailarr = this.formModel.ccStr.split(',')
            /*校验数组的每一项是否符合规则*/
            emailarr = emailarr.map(item => item.trim())
            this.formModel.bccStr = emailarr.join(',')
            if (emailarr.some(item => !this.validateEmail(item))) {
                this.$message.error('抄送人邮箱格式不正确')
                flag = false
                return
            }
        }
        if (this.formModel.bccStr) {
            let emailarr1 = this.formModel.bccStr.split(',')
            emailarr1 = emailarr1.map(item => item.trim())
            this.formModel.bccStr = emailarr1.join(',')
            if (emailarr1.some(item => !this.validateEmail(item))) {
                this.$message.error('密送人邮箱格式不正确')
                flag = false
                return
            }
        }

        /*标签更换字符*/
        //抄送

        let ccStrArr = this.checkedTags.join(',')

        // 将所有的班主任/项目负责人 替换成 ${teacherUserId}
        ccStrArr = ccStrArr.replace(/班主任\/项目负责人/g, '${teacherUserId}')
        ccStrArr = ccStrArr.replace(/论文班主任/g, '${thesisUserId}')
        ccStrArr = ccStrArr.replace(/小助手/g, '${helperUserId}')
        ccStrArr = ccStrArr.replace(/订单负责人/g, '${directorUserId}')
        let ccStr = this.formModel.ccStr + ',' + ccStrArr
        /*如果csStr只有一个逗号 则删掉逗号*/
        ccStr = ccStr.replace(/,/g, function (match, index) {
            if (index == 0) {
                return ''
            } else if (index == ccStr.length - 1) {
                return ''
            } else {
                return ','
            }
        })

        // 密送
        let bccStrArr = this.checkedSecretTags.join(',')

        // 将所有的班主任/项目负责人 替换成 ${teacherUserId}
        bccStrArr = bccStrArr.replace(/班主任\/项目负责人/g, '${teacherUserId}')
        bccStrArr = bccStrArr.replace(/论文班主任/g, '${thesisUserId}')
        bccStrArr = bccStrArr.replace(/小助手/g, '${helperUserId}')
        bccStrArr = bccStrArr.replace(/订单负责人/g, '${directorUserId}')
        let bccStr = this.formModel.bccStr + ',' + bccStrArr
        bccStr = bccStr.replace(/,/g, function (match, index) {
            if (index == 0) {
                return ''
            } else if (index == bccStr.length - 1) {
                return ''
            } else {
                return ','
            }
        })
        // 正文
        this.formModel.contentStr = this.editor.txt.html()

        let str = this.editor.txt.html();
         // 使用正则表达式全局替换，处理可能的属性顺序变化
        str = str.replace(/<input[^>]*value="学生姓名"[^>]*>/g, '${customerName}');
        str = str.replace(/<input[^>]*value="开课时间"[^>]*>/g, '${souCourseSchoolBegin}');
        str = str.replace(/<input[^>]*value="项目名称"[^>]*>/g, '${souCourseName}');

        if (!flag) {
            return
        } else {
            this.disabledBtn = true
        }

        const obj: any = {
            name: this.formModel.name,
            souCourseTypeId: this.formModel.souCourseTypeId,
            contentStr: str,
            subjectStr: this.formModel.subjectStr,
            ccStr: ccStr,
            bccStr: bccStr,
            emailUser: this.formModel.emailUser,
        }
        this.loading = true
        updateOutputTemplate(this.recordId, obj).then(res => {
            this.$message.success('编辑保存成功')
            this.disabledBtn = false
            this.loading = false
            setTimeout(() => {
                window.close()
            }, 500)
        }).catch(() => {
            this.disabledBtn = false
            this.loading = false
        })
    }


    getDataInfo() {
        getOutputTemplateById(this.recordId).then((res: any) => {
            this.formModel = res.outputTemplate

            this.formModel.types = res.outputTemplate.types ? (res.outputTemplate.types === '预警模板' ? '1' : '0') : '0'

            /*符合规则的替换，其他的删除*/
            const ccStrSArr = []
            if (this.formModel.ccStr) {
                this.checkedTags = this.formModel.ccStr.split(',').map(item => {
                        if (item == '${thesisUserId}') {
                            return '论文班主任'
                        } else if (item == '${helperUserId}') {
                            return '小助手'
                        } else if (item == '${teacherUserId}') {
                            return '班主任/项目负责人'
                        } else if (item == '${directorUserId}') {
                            return '订单负责人'
                        } else {
                            /*以上几种情况都不符合则删掉item*/
                            ccStrSArr.push(item)
                            return ''
                        }
                    }
                )
            }
            /*过滤掉数组里面的空字符串*/
            this.checkedTags = this.checkedTags.filter(item => item)
            this.formModel.ccStr = ccStrSArr.join(',')
            const bccStrSArr = []
            if (this.formModel.bccStr) {
                this.checkedSecretTags = this.formModel.bccStr.split(',').map(item => {
                    if (item == '${thesisUserId}') {
                        return '论文班主任'
                    } else if (item == '${helperUserId}') {
                        return '小助手'
                    } else if (item == '${teacherUserId}') {
                        return '班主任/项目负责人'
                    } else if (item == '${directorUserId}') {
                        return '订单负责人'
                    } else {
                        /*以上几种情况都不符合则删掉item*/
                        bccStrSArr.push(item)
                        return ''
                    }
                })
            }
            /*过滤掉数组里面的空字符串*/
            this.checkedSecretTags = this.checkedSecretTags.filter(item => item)
            this.formModel.bccStr = bccStrSArr.join(',')

            this.formModel.contentStr = this.formModel.contentStr.replace(/\${customerName}/g, '<input type="button" value="学生姓名" style="border-width: 1px; border-style: solid; border-color: rgb(217, 236, 255); border-radius: 5px; padding-right: 5px; padding-left: 5px; background: rgb(237, 245, 255); color: rgb(70, 159, 255); height: 24px; line-height: 24px;"/>')
            this.formModel.contentStr = this.formModel.contentStr.replace(/\${souCourseSchoolBegin}/g, '<input type="button" value="开课时间" style="border-width: 1px; border-style: solid; border-color: rgb(217, 236, 255); border-radius: 5px; padding-right: 5px; padding-left: 5px; background: rgb(237, 245, 255); color: rgb(70, 159, 255); height: 24px; line-height: 24px;"/>')
            this.formModel.contentStr = this.formModel.contentStr.replace(/\${souCourseName}/g, '<input type="button" value="项目名称" style="border-width: 1px; border-style: solid; border-color: rgb(217, 236, 255); border-radius: 5px; padding-right: 5px; padding-left: 5px; background: rgb(237, 245, 255); color: rgb(70, 159, 255); height: 24px; line-height: 24px;"/>')
            this.editor.txt.html(this.formModel.contentStr)
        })
    }
}
